import { hydrateRoot } from 'react-dom/client';
import { Globals } from '@bwoty-web/ui-kit';
import GeoInformationView from '../shared/views/geoInformation/geoInformationView';

const initialStateGeoInformation = window.__INITIAL_STATE_GEO_INFORMATION__;
delete window.__INITIAL_STATE_GEO_INFORMATION__;
const geoInformationRoot = document.getElementById('geo-information-view');

if (geoInformationRoot) {
  const { siteId, legacyMode, geoInformation, itemType } =
    initialStateGeoInformation;

  hydrateRoot(
    geoInformationRoot,
    <Globals siteId={siteId} legacyMode={legacyMode}>
      <GeoInformationView geoInformation={geoInformation} itemType={itemType} />
    </Globals>,
  );
}
